import { render, staticRenderFns } from "./CostConsultation.vue?vue&type=template&id=ee0a8b90&scoped=true&"
import script from "./CostConsultation.vue?vue&type=script&lang=js&"
export * from "./CostConsultation.vue?vue&type=script&lang=js&"
import style0 from "./CostConsultation.vue?vue&type=style&index=0&id=ee0a8b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0a8b90",
  null
  
)

export default component.exports